import * as React from "react"
// import { DogShipmentPriceEstimate } from "@citizenshipper/widgets-react"

import Head from "next/head"

import CanonicalLinkTag from "../components/head/CanonicalLinkTag"

import Layout from "../components/layout"

const DogWidget = () => {
  const [renderWidget, setRenderWidget] = React.useState(false)
  React.useEffect(() => {
    window.__csHosts__ = {
      api: "https://daedalus.stage.citizenshipper.com",
      shipmentForm: "https://app.stage.citizenshipper.com",
    }

    setRenderWidget(true)
  }, [])

  if (!renderWidget) {
    return null
  }

  return (
    <>
      <Head>
        <CanonicalLinkTag name="dog-widget" />
        <meta name="robots" content="noindex" />
      </Head>
      <Layout>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100vh",
            padding: "1rem",
          }}
        >
          <div
            style={{
              maxWidth: 450,
              width: "100%",
            }}
          >
            {/* <DogShipmentPriceEstimate
              dog={dog}
              pickupAddress={pickupAddress}
              apiKey={apiKey}
            /> */}
          </div>
        </div>
      </Layout>
    </>
  )
}

export default DogWidget
